import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { HomeComponent } from "./home/home.component";
import { CommonModule } from '@angular/common';
import { Dotcom2024Service } from './dotcom2024.service';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MyharrellsService } from './myharrells.service';
import { MyharrellsloginpromptComponent } from "./myharrellsloginprompt/myharrellsloginprompt.component";

@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    imports: [RouterOutlet, HomeComponent, CommonModule, FormsModule, MyharrellsloginpromptComponent]
})
export class AppComponent {

  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";// + "/Login/";
  filePaths: string = environment.azureBlobStorageURL + environment.baseFilesPathBlobStorage + "/";
  resourceImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Resources/";

  displayFailureAlert: boolean = false;
  failureText: string = "";

  loggedInUser: any = null;
  isAdmin: boolean = false;
  isHovered: boolean = false;


  allWarehouses: any[] = [];
  allWarehousesFirstThird: any[] = [];
  allWarehousesSecondThird: any[] = [];
  allWarehousesLastThird: any[] = [];


  searchResults: any[] = [];
  productResults: any[] = [];
  sdsResults: any[] = [];
  labelResults: any[] = [];
  empResults: any[] = [];
  blogResults: any[] = [];
  invoiceResults: any[] = [];
  educationResults: any[] = [];

  subscriptionSearchResults: Subscription

  dot1: boolean = false;
  dot2: boolean = false;
  dot3: boolean = false;
  dot4: boolean = false;
  dot5: boolean = false;
  dot6: boolean = false;
  dot7: boolean = false;
  dot8: boolean = false;



  constructor(public myHarrellsService: MyharrellsService, public dotComService: Dotcom2024Service, public router: Router, public route: ActivatedRoute) {

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
        this.dotComService.activePage = "";
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        if (this.router.url.toString().toLowerCase().indexOf("people") > -1) {
          this.dotComService.activePage = "people";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("products") > -1) {
          this.dotComService.activePage = "products";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("markets") > -1) {
          this.dotComService.activePage = "markets";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("resources") > -1) {
          this.dotComService.activePage = "resources";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("locations") > -1) {
          this.dotComService.activePage = "locations";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("careers") > -1) {
          this.dotComService.activePage = "careers";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("contacts") > -1) {
          this.dotComService.activePage = "contacts";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("peat") > -1) {
          this.dotComService.activePage = "peat";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("myharrellslogin") > -1) {
          this.dotComService.activePage = "myharrellslogin";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("knowledge") > -1) {
          this.dotComService.activePage = "knowledge";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("education") > -1) {
          this.dotComService.activePage = "education";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("forms") > -1) {
          this.dotComService.activePage = "forms";
        }
        else if (this.router.url.toString().toLowerCase().indexOf("calculators") > -1) {
          this.dotComService.activePage = "calculators";
        }

        //THIS ACTUALLY SETS THE BOLD TEXT IN THE MAIN MENU LINK DESCRIPTION - 
        //activemainmenu is only set when a user clicks a sublink or the main link- they must change route
        this.dotComService.activeMainMenu = sessionStorage.getItem('lastMainMenuHovered');

        // else {
        //   this.dotComService.activePage = "";
        // }

      }

      if (event instanceof NavigationError) {
        // Hide loading indicator
        // this.dotComService.activePage = "";

      }
    });
  }


  onActivate($event: any) {
    //this makes it scroll to the top of the page when a new page is loaded
    if (typeof window !== "undefined") {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'instant' //'smooth'
      });
    }

    console.log("viewport size: " + this.myHarrellsService.getViewport());
    this.myHarrellsService.bootstrapViewPortSize = this.myHarrellsService.getViewport();


    //ctrl f5  was throwing out the logged in user - if the sessions storeage has the user logged in, reset the variable
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('loggedInMyHarrellsUser')) {
      let loggedInUser = JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser'));
      if (loggedInUser != null) {
        this.myHarrellsService.loggedInMyHarrellsUser = loggedInUser;
      }
    }

  }

  ngAfterViewInit() {
    //do not remove this or the page will also display the applicant manager output at the bottom of the page
    //if you search on "theapplicantmanager" in the code you will see where this is used
    //this hides the applicant manager output all the time
    //we take the contents of this page and display it in the careers page but never
    //show their page 

    if (typeof document !== 'undefined') {
      let x = document.getElementById("theapplicantmanager");
      if (x) {
        x.style.display = 'none';
      }
    }

    if (typeof sessionStorage !== 'undefined') {
      this.myHarrellsService.onlineOrderingInEffect = (sessionStorage.getItem('onlineOrderingInEffect') == 'true' ? true : false);
    }

    if (typeof document !== 'undefined') {
      const hamMenu = document.querySelector(".ham-menu");
      const offScreenMenu = document.querySelector(".off-screen-menu");

      if (hamMenu && offScreenMenu) {
        hamMenu.addEventListener("click", () => {
          hamMenu.classList.toggle("active");
          offScreenMenu.classList.toggle("active");
        });
      }
    }

    //only building because the locations submenu needs the array of warehouses
    //no need to build this more than once per session 
    if (!sessionStorage.getItem('warehouses')) {
      console.log("warehouses not in session storage - getting them from the api");
      this.dotComService.GetLocations().then(results => {
        let x = this.dotComService.warehouses;
        x.sort((a, b) => (a.alt_name < b.alt_name) ? -1 : 1)
        sessionStorage.setItem('warehouses', JSON.stringify(x));
        this.allWarehouses = JSON.parse(sessionStorage.getItem('warehouses'));
        this.allWarehousesFirstThird = this.allWarehouses.slice(0, Math.ceil(this.allWarehouses.length / 3));
        this.allWarehousesSecondThird = this.allWarehouses.slice(Math.ceil(this.allWarehouses.length / 3), Math.ceil(this.allWarehouses.length / 3) * 2);
        this.allWarehousesLastThird = this.allWarehouses.slice(Math.ceil(this.allWarehouses.length / 3) * 2, this.allWarehouses.length);
      })
    }
    else {
      this.dotComService.GetLocations().then(results => {
        let x = this.dotComService.warehouses;
        x.sort((a, b) => (a.alt_name < b.alt_name) ? -1 : 1)
        sessionStorage.setItem('warehouses', JSON.stringify(x));
        this.allWarehouses = JSON.parse(sessionStorage.getItem('warehouses'));
        this.allWarehousesFirstThird = this.allWarehouses.slice(0, Math.ceil(this.allWarehouses.length / 3));
        this.allWarehousesSecondThird = this.allWarehouses.slice(Math.ceil(this.allWarehouses.length / 3), Math.ceil(this.allWarehouses.length / 3) * 2);
        this.allWarehousesLastThird = this.allWarehouses.slice(Math.ceil(this.allWarehouses.length / 3) * 2, this.allWarehouses.length);
      })
    }

    //need this for the search results so building it up front
    this.myHarrellsService.GetMatrixLMSCourses().subscribe((data: any) => {
      //this returns them all (myharrells, marketing, compliance, etc)
      //we will filter them down to just the education ones - brandon/allison marking the field course code with the word 'myHarrells'
      this.myHarrellsService.matrixCourseList = data.filter(x => x.course_code != null);
      this.myHarrellsService.matrixCourseList = this.myHarrellsService.matrixCourseList.filter(x => x.course_code.toLowerCase().includes('myharrells'));
      //sourt by course name
      this.myHarrellsService.matrixCourseList.sort((a, b) => (a.name > b.name) ? 1 : -1);
    })
  }



  QuickFilterChanged() {

    this.searchResults = [];
    this.productResults = [];
    this.sdsResults = [];
    this.labelResults = [];
    this.empResults = [];
    this.blogResults = [];
    this.invoiceResults = [];
    this.educationResults = [];

    this.displayFailureAlert = false;
    this.failureText = "";

    if (this.dotComService.quickSearchInput.trim().length > 0) {
      //check if user is logged into myharrells.  if so they also search for their 
      //customers invoices 
      this.loggedInUser = JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser'));
      if (this.loggedInUser == null) {
        this.loggedInUser = "";
      }
      else {
        //check if user is an admin 
        this.isAdmin = (this.loggedInUser && this.loggedInUser.RoleName.indexOf('HarrellsAdmin') > -1)
      }

      if (this.subscriptionSearchResults) {
        this.subscriptionSearchResults.unsubscribe();
      }


      this.subscriptionSearchResults = this.dotComService.GetSiteSearch('quick', this.dotComService.quickSearchInput, this.loggedInUser.Email, this.isAdmin).subscribe(data => {
        this.searchResults = data;

        //now checking for search results from the matrix system for education posts logged there
        let matrixPostsForSearch = this.myHarrellsService.matrixCourseList.filter(x => x.name.indexOf('pond') > -1 || x.short_description.indexOf('pond') > -1)
        if (matrixPostsForSearch.length > 0) {
          for (let i = 0; i < matrixPostsForSearch.length; i++) {
            let element = matrixPostsForSearch[i];

            const month = String(new Date(element.metadata.created_at).getMonth() + 1);
            const day = String(new Date(element.metadata.created_at).getDate());
            const year = new Date(element.metadata.created_at).getFullYear();
            element.RevisionPublishDate = month + '/' + day + '/' + year;

            element.RevisionPublishDateSort = String(new Date(element.RevisionPublishDate).getFullYear()) + String(new Date(element.RevisionPublishDate).getMonth() + 1).padStart(2, '0') + String(new Date(element.RevisionPublishDate).getDate()).padStart(2, '0');

            // //categories 
            // if (element.tags.filter(ii => ii.indexOf('cat-') > -1).length > 0) {
            //   //element.Categories = element.tags.filter(ii => ii.indexOf('cat-') > -1).map(ii => ii.replace('cat-', ''));
            // }

            data.push({
              IsMatrixPost: true,
              Id: element.id, //used to forward to the matrix post 
              SearchResultType: "ed",
              WebName: element.name,
              Name: element.name,
              RevisionPublishDate: element.RevisionPublishDate,
              RevisionPublishDateSort: element.RevisionPublishDateSort,
              Category: element.Categories,
              PostSummary: element.short_description,
              Title: element.name,
              LoggedInUserName: element.organization_name,
            });
          }
        }




        //PRODUCTS DATA IF ANY 
        this.productResults = data.filter(x => x.SearchResultType == "p");
        this.productResults = this.productResults.sort((a, b) => (a.WebName < b.NamWebNamee) ? -1 : 1)
        this.sdsResults = this.productResults;
        this.labelResults = this.productResults;


        //EMPLOYEES DATA IF ANY
        this.empResults = [];
        let empResultsFilter = data.filter(x => x.SearchResultType == "e");

        //check if employee photo exists
        for (let index = 0; index < empResultsFilter.length; index++) {
          const element = empResultsFilter[index];
          this.empResults.push({ Email: element.Email, Name: element.Name, ImgURL: this.pageImagePaths + "EmployeePhotos/" + element.Id + ".jpg", Title: element.Title, Phone: element.Phone, Id: element.Id })
          if (index == empResultsFilter.length - 1) {
            this.empResults = this.empResults.sort((a, b) => (a.Name < b.Name) ? -1 : 1)
          }
        }

        //BLOGS DATA IF ANY 
        let blogResultsFiltered = data.filter(x => x.SearchResultType == "b");

        for (let i = 0; i < blogResultsFiltered.length; i++) {
          let element = blogResultsFiltered[i];

          element.RevisionPublishDate = element.RevisionPublishDate.substring(0, element.RevisionPublishDate.indexOf(' ')).replace('1/1/9999', '');
          element.RevisionPublishDateSort = String(new Date(element.RevisionPublishDate).getFullYear()) + String(new Date(element.RevisionPublishDate).getMonth() + 1).padStart(2, '0') + String(new Date(element.RevisionPublishDate).getDate()).padStart(2, '0');

          this.blogResults.push(element);
          if (i == blogResultsFiltered.length - 1) {
            this.blogResults = this.blogResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
          }
        }

        //INVOICES DATA IF ANY AND IF USER IS LOGGED IN 
        this.invoiceResults = [];
        let invoiceResultsFiltered = data.filter(x => x.SearchResultType == "iv");

        for (let i = 0; i < invoiceResultsFiltered.length; i++) {
          let element = invoiceResultsFiltered[i];
          element.DocumentDate = element.DocumentDate.substring(0, element.DocumentDate.indexOf(' ')).replace('1/1/9999', '');
          this.invoiceResults.push(element);
          if (i == invoiceResultsFiltered.length - 1) {
            this.invoiceResults = this.invoiceResults.sort((a, b) => (a.DocumentDate < b.DocumentDate) ? -1 : 1)
          }
        }

        //EDUCATION DATA IF ANY 
        this.educationResults = [];
        let educationResultsFiltered = data.filter(x => x.SearchResultType == "ed");

        for (let i = 0; i < educationResultsFiltered.length; i++) {
          let element = educationResultsFiltered[i];

          element.RevisionPublishDate = element.RevisionPublishDate.substring(0, element.RevisionPublishDate.indexOf(' ')).replace('1/1/9999', '');
          element.RevisionPublishDateSort = String(new Date(element.RevisionPublishDate).getFullYear()) + String(new Date(element.RevisionPublishDate).getMonth() + 1).padStart(2, '0') + String(new Date(element.RevisionPublishDate).getDate()).padStart(2, '0');


          this.educationResults.push(element);
          if (i == educationResultsFiltered.length - 1) {
            this.educationResults = this.educationResults.sort((a, b) => (a.RevisionPublishDateSort < b.RevisionPublishDateSort) ? 1 : -1)
          }
        }

      })
    }
    else {
      if (this.dotComService.quickSearchInput.trim().length > 0) {
        this.displayFailureAlert = true;
        this.failureText = "Please enter a search term that is at least 3 characters long.";
      }
    }
  }

  OpenPdfDoc(docType: string, id2: string) {
    this.myHarrellsService.GetPDFDocument(docType, id2).subscribe((response: any) => {
      if (response.length == 0) {
        this.displayFailureAlert = true;
        this.failureText = "There was an error retrieving the PDF document.  Please try again later.";
      }
      else {
        let PDFWindow = window.open(response[0].DocName, '_blank');

        this.CloseSearchDropdown();

      }
    })
  }

  GetSDS(product: any) {
    this.dotComService.getDocument('sds', product.ItemNmbr)
      .subscribe(response => {

        if (response && response.length > 0 && response[0] && response[0].FileExists == false) {
          this.dotComService.displaySDSNotice = true
        } else if (response && response.length > 0 && response[0]) {
          window.open(response[0].DocName, "_blank");
        }
      });
  }

  GetLabel(product: any) {
    this.dotComService.getDocument('label', product.ItemNmbr)
      .subscribe(response => {

        if (response.length == 0 || response[0].FileExists == false) {
          this.dotComService.displayLabelNotice = true
        }
        else {
          window.open(response[0].DocName, "_blank");
        }
      })
  }

  ViewProductsDetail(product: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/product'],
        { queryParams: { sku: product.ItemNmbr } })

      this.CloseSearchDropdown();

    });
  }

  GoToBlog(blog: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/blog'],
        { queryParams: { id: blog.WebName } })

      this.CloseSearchDropdown();

    });
  }

  // GoToEducationPost(post: any) {
  //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
  //     this.router.navigate(['/post'],
  //       { queryParams: { id: post.WebName } })

  //     this.CloseSearchDropdown();

  //   });
  // }


  GoToEducationPostSearchPage(post?: any) {
    if (post.IsMatrixPost) {
      if (!this.loggedInUser || this.loggedInUser == '') {
        this.myHarrellsService.selectedCourse = post;
        this.myHarrellsService.courseIdToUse = post.Id;
        this.OpenLoginModal(post);

        this.CloseSearchDropdown();
      }
      else {
        //this is a matrix post so we need to go to the matrix post page
        //go to the matrix platform to display the course - not using legacy education post for this one 
        this.myHarrellsService.courseAliasSelected = ""; //courseSelected.ItemAlias;
        this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = post.Id;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigateByUrl('/matrix');
        });

        this.CloseSearchDropdown();
      }
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/post'],
          { queryParams: { id: post.WebName } })
      });

       this.CloseSearchDropdown();
    }
  }

  CloseSearchDropdown() {
    //in case it is in the middle of the query but not returned yet
    if (this.subscriptionSearchResults) {
      this.subscriptionSearchResults.unsubscribe();
    }

    this.searchResults = [];
    this.productResults = [];
    this.empResults = [];
    this.blogResults = [];
    this.invoiceResults = [];
    this.educationResults = [];

    this.displayFailureAlert = false;
    this.failureText = "";

    this.dotComService.quickSearchInput = "";
  }

  HideLabelNotFoundNotice() {
    this.dotComService.displayLabelNotice = false
  }

  HideSDSNotFoundNotice() {
    this.dotComService.displaySDSNotice = false
  }

  HideWarningAlert() {
    this.dotComService.displayWarning = false;
    this.dotComService.warningText = "";
  }

  HideSuccessAlert() {
    this.dotComService.displaySuccess = false;
    this.dotComService.successText = "";
  }

  GoToCart() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/cart'])
    });
  }

  GetCategoryGroupItems(categoryGroupName: string) {
    this.dotComService.GetProductCategoryGroup(categoryGroupName).subscribe(data => {
      var categoriesInGroup = "";

      for (let i = 0; i < data.length; i++) {
        categoriesInGroup += data[i].WebCategory + ",";
      }

      categoriesInGroup = categoriesInGroup.substring(0, categoriesInGroup.length - 1);

      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/products'], { queryParams: { filter: categoriesInGroup } })
      });
    })
  }

  ShowDots() {
    //delay for 2 seconds
    setTimeout(() => {
      this.dot1 = true;
    }, 1 * 1000);

    //delay code from running for 1 second
    this.dot1 = false;
    this.dot2 = false;
    this.dot3 = false;
    this.dot4 = false;
    this.dot5 = false;
    this.dot6 = false;
    this.dot7 = false;
    this.dot8 = false;
    for (let i = 0; i < 30; i++) {
      //do nothing
      setTimeout(() => {
        if (i == 1) this.dot1 = true;
        if (i == 2) this.dot2 = true;
        if (i == 3) this.dot3 = true;
        if (i == 4) this.dot4 = true;
        if (i == 5) this.dot5 = true;
        if (i == 6) this.dot6 = true;
        if (i == 7) this.dot7 = true;
        if (i == 8) this.dot8 = true;
      }, 1 * 1000);
    }
  }

  GoToMainSearch() {
    //populate the variable the main search page needs
    this.dotComService.searchTerm = this.dotComService.quickSearchInput;
    this.CloseSearchDropdown();
    //go to the page and fire off the search feature (same as leaving the input box in the main search page)
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/search'])
    });
  }

  ToggleMobileMenu() {
    this.myHarrellsService.displayMobileMenu = !this.myHarrellsService.displayMobileMenu;
  }

  GoToRep(rep: any) {
    this.dotComService.GetAllReps(rep.Id).subscribe(reps => {
      if (reps.length == 0) {
        //the employee selected does not have a rep record - prob not a rep 
        //go to the detail search page as the employee is not a rep 
        this.dotComService.searchTerm = rep.Name;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/search'], { queryParams: { searchTerm: rep.Name } })
        });
        this.CloseSearchDropdown();
      }
      else {
        this.dotComService.repsMasterList = reps;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/rep'],
            { queryParams: { id: rep.Id } })
          this.CloseSearchDropdown();
        });
      }
    }
    )
  }

  OpenLoginModal(course: any) {
    this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = course.Id;
    document.getElementById("loginModal").style.display = "block";
  }

}







